import QueryBuilder from "../QueryBuilder"

export default class SimpleCalloutRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "imagePanel",
            ])
            .process()

        return results.getResultInfo()
    }
}
